import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { ArrowDownward, ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { phoneMediaQuery, rescheduleTheme } from '../rescheduleTheme';
import { RescheduleTypography } from './RescheduleTypography';

type FromToCardsProps = {
  fromText: string;
  toText: string;
};

const labelStyle = {
  fontSize: 13,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
} as const;

export const FromToCards = ({ fromText, toText }: FromToCardsProps) => {
  const { t, i18n } = useTranslation();
  const isPhone = useMediaQuery(phoneMediaQuery);
  const isRtl = i18n.dir() === 'rtl';

  const arrowSx = { color: rescheduleTheme.brand, transform: isRtl && !isPhone ? 'scaleX(-1)' : undefined };
  const cardRadius = `${isPhone ? rescheduleTheme.radii.cardMobile : rescheduleTheme.radii.card}px`;

  return (
    <Grid
      component="section"
      container
      alignItems="stretch"
      sx={{
        display: 'grid',
        gridTemplateColumns: isPhone ? 'minmax(0, 1fr)' : 'minmax(0, 1fr) 40px minmax(0, 1fr)',
      }}>
      <Grid
        container
        flexDirection="column"
        flexWrap="nowrap"
        sx={{
          border: `1px solid ${rescheduleTheme.border}`,
          borderRadius: cardRadius,
          padding: isPhone ? '14px 16px' : '18px 20px',
          gap: '6px',
          background: rescheduleTheme.surfaceMuted,
        }}>
        <RescheduleTypography style={{ ...labelStyle, color: rescheduleTheme.textMuted }}>
          {t('manage_booking.v2.nowLabel')}
        </RescheduleTypography>
        <RescheduleTypography
          dir="ltr"
          style={{
            fontSize: 17,
            fontWeight: 500,
            color: rescheduleTheme.textMuted,
            textDecoration: 'line-through',
            textAlign: 'start',
          }}>
          {fromText}
        </RescheduleTypography>
      </Grid>
      <Grid
        container
        aria-hidden="true"
        alignItems="center"
        justifyContent="center"
        sx={{ padding: isPhone ? '4px' : 0 }}>
        {isPhone ? <ArrowDownward sx={arrowSx} /> : <ArrowForward sx={arrowSx} />}
      </Grid>
      <Grid
        container
        flexDirection="column"
        flexWrap="nowrap"
        sx={{
          border: `2px solid ${rescheduleTheme.brand}`,
          borderRadius: cardRadius,
          padding: isPhone ? '13px 15px' : '17px 19px',
          gap: '6px',
          background: rescheduleTheme.brandTint,
        }}>
        <RescheduleTypography style={{ ...labelStyle, color: rescheduleTheme.brand, fontWeight: 600 }}>
          {t('manage_booking.v2.newLabel')}
        </RescheduleTypography>
        <RescheduleTypography dir="ltr" style={{ fontSize: 17, fontWeight: 600, textAlign: 'start' }}>
          {toText}
        </RescheduleTypography>
      </Grid>
    </Grid>
  );
};
